export default "__VITE_ASSET__DMVfJ9Nq__"